module.exports = __webpack_public_path__ + "static/vidhanasouda-be89a9297a06bd0399e0e1e88bfc13bf.png";